module.exports = __webpack_public_path__ + "img/icon_subscription_on.4f202e6f.svg";